import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  marketid: [
    {...makeRule('请选择一个卖场', 'integer')},
  ],
  distance: [
    {...makeRule('查询距离最少为100m', 'number')},
  ],
}

export let formRules = {}



// WEBPACK FOOTER //
// ./src/views/user-cover/user-cover.rules.js